import type { Ref } from 'vue'
import { useHandleEscapeKey } from './useHandleEscapeKey'

export function useEmitCloseOnEscapeKey(
    emit: (event: 'close') => void,
    isOpen?: Readonly<Ref<boolean>>
): void {
    useHandleEscapeKey(() => {
        if (isOpen === undefined || isOpen.value) {
            emit('close')
        }
    }, isOpen)
}
